import { createAction, props } from '@ngrx/store';
import { WorkOrderFile } from './work-order-files.model';

export const openWorkOrderFile = createAction('[Work Order] (File) Open', props<{ file: WorkOrderFile }>());
